import React from 'react';
import { FiX, FiBook } from 'react-icons/fi';

interface MyTopicsModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  error: string | null;
  topics: any[];
  onOpenTopic: (doc: any) => void;
}

const MyTopicsModal: React.FC<MyTopicsModalProps> = ({ isOpen, onClose, isLoading, error, topics, onOpenTopic }) => {
  if (!isOpen) return null;

  return (
    <div className="exam-mode-overlay" onClick={onClose} style={{ zIndex: 1000 }}>
      <div
        className="exam-mode-dialog"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          margin: 0,
          borderRadius: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="exam-mode-header">
          <h2>My Exam Topics</h2>
          <button className="exam-mode-close" onClick={onClose} aria-label="Close my topics">
            <FiX size={24} />
          </button>
        </div>
        <div className="exam-mode-content" style={{ flex: 1, overflowY: 'auto' }}>
          {isLoading && (
            <div className="loading-sessions" style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
              <span className="loading-text">Loading…</span>
            </div>
          )}
          {error && (
            <div className="sessions-error">
              <span className="error-text">{error}</span>
            </div>
          )}
          {!isLoading && !error && (
            <div style={{ display: 'grid', rowGap: 12 }}>
              {topics.length === 0 ? (
                <span style={{ opacity: 0.8 }}>No saved exam topics.</span>
              ) : (
                topics.map((doc: any, idx: number) => {
                  const title = doc?.examType || doc?.examName || doc?.subject || `Exam ${idx + 1}`;
                  const createdAt = doc?.createdAt ? new Date(doc.createdAt).toLocaleString() : '';
                  return (
                    <button
                      key={doc?._id || idx}
                      onClick={() => onOpenTopic(doc)}
                      style={{
                        textAlign: 'left',
                        padding: '12px 14px',
                        borderRadius: 8,
                        border: '1px solid #e2e8f0',
                        background: '#fff',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                      }}
                      title={title}
                    >
                      <FiBook style={{ color: '#334155' }} />
                      <div style={{ display: 'grid' }}>
                        <span style={{ fontWeight: 700, color: '#1e293b' }}>{title}</span>
                        {createdAt && <span style={{ fontSize: 12, color: '#64748b' }}>{createdAt}</span>}
                      </div>
                    </button>
                  );
                })
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyTopicsModal;
